import { Node } from 'tiptap'
import MerlinImage from '@/components/tiptap/extensions/MerlinImage.vue'

export default class MerlinImgNode extends Node {
    get name () {
        return 'merlin_image_node'
    }

    get schema () {
        return {
            // here you have to specify all values that can be stored in this node
            attrs: {
                merlinid: {
                    default: null
                },
                align: {
                    default: null
                },
                alt: {
                    default: null
                },
                caption: {
                    default: null
                },
                credit: {
                    default: null
                },
                description: {
                    default: null
                },
                src: {
                    default: null
                },
                width: {
                    default: null
                },
                style: {
                    default: null
                },
                extension: {
                    default: null
                },
                customClass: {
                    default: null
                },
            },
            group: 'block',
            content: 'inline*',
            // group: 'inline',
            // inline: true,
            draggable: true,
            // parseDOM and toDOM is still required to make copy and paste work
            parseDOM: [{
                tag: 'merlin-img',
                getAttrs: dom => ({
                    merlinid: dom.getAttribute('merlinid'),
                    align: dom.getAttribute('align'),
                    alt: dom.getAttribute('alt'),
                    caption: dom.getAttribute('caption'),
                    credit: dom.getAttribute('credit'),
                    description: dom.getAttribute('description'),
                    src: dom.getAttribute('src'),
                    width: dom.getAttribute('width'),
                    style: dom.getAttribute('style'),
                    extension: dom.getAttribute('extension'),
                    customClass: dom.getAttribute('customClass'),
                }),
            }],
            toDOM: node => ['merlin-img', {
                merlinid: node.attrs.merlinid,
                align: node.attrs.align,
                alt: node.attrs.alt,
                caption: node.attrs.caption,
                credit: node.attrs.credit,
                description: node.attrs.description,
                src: node.attrs.src,
                width: node.attrs.width,
                style: node.attrs.style,
                extension: node.attrs.extension,
                class: node.attrs.customClass,
            }]
        }
    }

    commands ({ type }) {
        return (attrs) => (state, dispatch) => {
            dispatch(state.tr.replaceSelectionWith(type.create({
                'merlinid': (attrs) ? attrs.merlinid : null,
                'src': (attrs) ? attrs.src : null,
                'alt': (attrs) ? attrs.alt : null,
                'caption': (attrs) ? attrs.caption : null,
                'credit': (attrs) ? attrs.credit : null,
                'description': (attrs) ? attrs.description : null,
                'width': (attrs) ? attrs.width : null,
                'align': (attrs) ? attrs.align : null,
                'style': (attrs) ? attrs.style : null,
                'extension': (attrs) ? attrs.extension : null,
                'customClass': (attrs) ? attrs.customClass : null,
            })))
        }
    }

    get view () {
        return MerlinImage
    }
}
